/**
 * package: com.inq.ui
 * class: Container
 * @extends com.inq.events.EventDispatcher
 * @constructor
 */
com.inq.ui.Container = function(_id,_parentNode,document) {
	com.inq.events.EventDispatcher.call(this);
	this._backgroundImage = null;
	this._visible = true;
	this._clientStage = js.Boot.__instanceof(this,com.inq.ui.ClientBody);
	this._isSprite = null;

	this.styles = {
		"zIndex": null,
		"visible": "true",
		"left": null,
		"top": null,
		"width": null,
		"height": null,
		"enabled": null
	};
	this.attributeMap = {};
	this.parent = null;
	this.document = document || window.document;

	if(com.inq.ui.SkinLoader.skinInClient) this.document = window.parent.document;

	/** @type {HTMLElement} */
	var element = this.determineExistingElement(_id);
	if(element != null) {
		this._div = element;
		this._div.container = this;
		this._parent = _parentNode || this._div.parentNode;
		this.styles["id"] = _id;
	} else {
		this._style = "position: absolute; left: 0px; top: 0px; width: 100px; height: 60px; overflow: hidden;";
		this._div = this.document.createElement("DIV");
		this._div.style.cssText = this._style;
	}
	this.addCssClass(this._div);
};
$hxClasses.extend(com.inq.events.EventDispatcher, com.inq.ui.Container, "com.inq.ui.Container");

/**
 * Check if element with _id is found in correct document object and return it.
 * If _id is not a string, this returns null.
 *
 * Note: Added to avoid touching the already widely used getElementById function
 *
 * @param {string} _id
 * @return {HTMLElement|null}
 */
com.inq.ui.Container.prototype.determineExistingElement = function(_id){
	if (com.inq.ui.Container.isString(_id)) {
		return com.inq.ui.Container.getElementById(_id);
	}
	return null;
};

/**
 * getElementById
 * Returns element found in correct document object.
 * If _id is not a string, this returns it back not changed.
 *
 * *
 * --------------------- *
 *
 * public static function getElementById(_id:Dynamic)
 * @public
 * @static
 * @param {string} _id
 * @return {HTMLElement}
 */
com.inq.ui.Container.getElementById = function(_id) {
	var el = null;
	if (com.inq.ui.Container.isString(_id)) {
		if(com.inq.ui.SkinLoader.skinInClient && _id.indexOf(com.inq.ui.Container.CLIENT_SPACE_PREFIX) == 0 || _id.indexOf(com.inq.ui.Container.LEGACY_PREFIX) == 0) {
			el = com.inq.ui.Container._getElementById(_id, window.parent.document);
		}
		if(el == null) {
			el = com.inq.ui.Container._getElementById(com.inq.ui.Container.CLIENT_SPACE_PREFIX + Std.string(_id), window.parent.document);
		}
		if (el == null) {
			el = com.inq.ui.Container._getElementById(_id)
		};
	} else el = _id;

	return el;
};


/**
 * _getElementById
 *
 * TODO: Why need this method? Enough #getElementById(id)
 *
 * private static function _getElementById(id:String, ?doc:Dynamic)
 * @private
 * @static
 * @param {string}  id
 * @param {null}  doc
 * @return {HTMLElement}
 */
com.inq.ui.Container._getElementById = function(id,doc) {
	if(doc == null) {
		doc = window.document;
	} else {
		if(doc == window.parent.document && window.getParentElByIDTFacade){
			return window.getParentElByIDTFacade(id);
		}
	}
	var el = doc.getElementById(id);
	/**
	 * very unrealistic code, how come the element being fetched above using an id will not match the same id.
	 */
	if(el != null && el.id != id) {
		/** @type {Array.HTMLElement} */
		var allElements = doc.getElementsByTagName("*");
		for (var i = 0; i < allElements.length; i++) {
			el = allElements[i];
			if(el != null && el.id == id) return el;
		}
		return null;
	}
	return el;
};


com.inq.ui.Container._getElementByTN = function(tn, doc) {
	if (doc == null) {
		doc = window.document;
	} else {
		if (doc == window.parent.document && window.getParentElsByTNTFacade) {
			var els = window.getParentElsByTNTFacade(tn);
			if(typeof els=="undefined" || !els){
				return [];
			}
			return els;
		}
	}
	return doc.getElementsByTagName(tn);
};


/**
 * find
 *
 * $type TFun([{ name => label, t => TInst(String,[]), opt => false }],TInst(com.inq.ui.Container,[]))
 * public static function find(label:String):Container
 * @public
 * @static
 * @param {string}  label
 * @return {?com.inq.ui.Container}
 */
com.inq.ui.Container.find = function(label) {
	/** @type {?HTMLElement} */
	var element = window.document.getElementById(label);
	/** @type {?com.inq.ui.Container} */
	var found = element != null ? element.container : null;
	return found;
};


/**
 * encodeSize
 *
 * static function encodeSize( size:String, ?defaultSuffix:String = "px"):String
 * @static
 * @param {string}  size
 * @param {string=}  defaultSuffix - optional
 * @return {string}
 */
com.inq.ui.Container.encodeSize = function(size,defaultSuffix) {
	if(defaultSuffix == null) defaultSuffix = "px";
	/** @type {RegExp} */
	var re = new RegExp("^[+-]?\\d*\\.?\\d*$");
	if (re.test(size)) {
		return size + defaultSuffix;
	} else {
		return size;
	}
};


/**
 * isString
 *
 * $type TFun([{ name => ob, t => TDynamic(null), opt => false }],TEnum(Bool,[]))
 * private static function isString(ob:Dynamic):Bool
 * @private
 * @static
 * @param {null}  ob
 * @return {boolean}
 */
com.inq.ui.Container.isString = function(ob) {
	if(null == ob) return false;
	return js.Boot.__instanceof(ob,String);
};


/**
 * show - make Container visible
 *
 * @public
 * @static
 * @param {string}  id - string - id of the container to made visible
 * @return {void}
 */
com.inq.ui.Container.show = function (id) {
	var cntr = Application.getContainer(id);
	if(cntr != null
	   && ( id !== 'chat' || !com.inq.flash.client.control.MinimizeManager.isMinimized() )
	   && ( id !== 'btnEmail' || com.inq.flash.client.chatskins.EmailMgr.getRequestStatus() !== com.inq.flash.client.chatskins.EmailMgr.REQUEST_STATUS_REQUESTED )
	) {
		if(com.inq.utils.Capabilities.isIphone() && id === "chat") {
			/*  @see RTDEV-13049
			 *  Calling ChatTextFocusMonitor.resizeToViewport() unlocks Zoom and breaks chat window when an input is next clicked.
			 *  When onBlur() is changed this should be checked too.
			 */
			com.inq.flash.client.chatskins.ChatTextFocusMonitor.onBlur();
		}
		cntr.setVisible("true");
		if (id === "chat") {
			com.inq.flash.client.chatskins.SkinControl.scrollTranscriptToEnd();
		}
		if (id === 'email') {
            com.inq.flash.client.chatskins.EmailMgr.showEmailCanvas();
        }
	}
	/*
	 * RTDEV-19317
	 * Set focus on the EndCall button of the Call dialog when the user click the "Return to Call" button on the
	 * switch page.
	 */
	if (id === "webCallA" && com.inq.flash.client.control.WebRTCMgr.isWebRTCCapable()) {
		var endCallBtn = Application.application.getButton("btnEndCallA");
		if (endCallBtn && endCallBtn._img) {
			endCallBtn._img.focus();
		}
	}
};


/**
 * hide - make Container invisible
 *
 * $type TFun([{ name => id, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * public static function hide(id:String)
 * @public
 * @static
 * @param {string}  id - string - id of the container to made visible
 * @return {void}
 */
com.inq.ui.Container.hide = function(id) {
	if(id === "email") {
		com.inq.flash.client.chatskins.EmailMgr.actionCancelEmail();
	} else {
		/** @type {com.inq.ui.Container} */
		var cntr = Application.getContainer(id);
		if (cntr != null) cntr.setVisible("false");
	}
	/*
	 * RTDEV-19523
	 * Restore the screen reader for chat when the "switch" canvas is hidden and the chat page will be shown.
	 */
	if (id === "switch") {
		com.inq.aria.AriaMsg.restoreScreenReaderForChat();
	}
};

// TODO should be remove when won't be used
com.inq.ui.Container.initializeClass = function (initFunc) {
	com.inq.flash.client.control.FlashPeer.logWarningToServer(
		"Container#initializeClass will be used for"
		+ " initFunc:" + initFunc
	);

	if (typeof window[initFunc] === "function") {
		window[initFunc]();
	} else {
		com.inq.flash.client.control.FlashPeer.logErrorToServer(
			"Container#initializeClass won't work, because initFunc:"
			+ initFunc + " isn't a function"
		);
	}
};

com.inq.ui.Container.playVideo = function (id) {
	/** @type {com.inq.ui.VideoPlayer} */
	var el = Application.application.getMxmlItem(id);
	if (el != null) {
		el.play();
	}
};

com.inq.ui.Container.pauseVideo = function (id) {
	/** @type {com.inq.ui.VideoPlayer} */
	var el = Application.application.getMxmlItem(id);
	if (el != null) {
		el.pause();
	}
};

com.inq.ui.Container.closeVideo = function (id) {
	/** @type {com.inq.ui.VideoPlayer} */
	var el = Application.application.getMxmlItem(id);
	if (el != null) {
		el.close();
	}
};

com.inq.ui.Container.stopVideo = function (id) {
	com.inq.ui.Container.closeVideo(id);
};

/**
 * addMxmlListeners
 * Add listeners to the Mxml containers
 *
 * $type TFun([],TEnum(Void,[]))
 * private function addMxmlListeners()
 * @private
 * @this com.inq.ui.Container
 * @return {void}
 */
com.inq.ui.Container.prototype.addMxmlListeners = function() {
	if(this.styles["onClick"]) {
		if(com.inq.ui.CommandParser.executeLogic(this.styles["onClick"],true,this)) this.setOnClick($bind(this,this.onClick));
	}
	/* Add onInit, this is init time so run it now*/
	if(this.styles["onInit"]) {
		if(com.inq.ui.CommandParser.executeLogic(this.styles["onInit"],true,this)) com.inq.ui.CommandParser.executeLogic(this.styles["onInit"],false,this);
	}
	/* For onVisible and onHidden just do the test to check syntax */
	if(this.styles["onVisible"]) {
		com.inq.ui.CommandParser.executeLogic(this.styles["onVisible"],true,this);
		if(this.getVisible()) com.inq.ui.CommandParser.executeLogic(this.styles["onVisible"],false,this);
	}

	if(this.styles["onHidden"]) {
		com.inq.ui.CommandParser.executeLogic(this.styles["onHidden"],true,this);
		if(!this.getVisible()) com.inq.ui.CommandParser.executeLogic(this.styles["onHidden"],false,this);
	}


	if(this.styles["onEnable"]) {
		com.inq.ui.CommandParser.executeLogic(this.styles["onEnable"],true,this);
		if(this.getEnabled()) com.inq.ui.CommandParser.executeLogic(this.styles["onEnable"],false,this);
	}
};


/**
 * onClick
 *
 * $type TFun([],TEnum(Void,[]))
 * private function onClick()
 * @protected
 * @this com.inq.ui.Container
 * @return {void}
 */
com.inq.ui.Container.prototype.onClick = function() {
	com.inq.ui.CommandParser.executeLogic(this.styles["onClick"],false,this);
};


/**
 * getNewImage - creates a new Image instance and assigns it to the target document
 * This is much needed because in the client page based chats the image is made in the
 * iframe containing the code (the ijsf iframe) but is placed in the main client page.
 * This is an error, so we must make sure that the image is "imported" into the client page via importNode
 *
 * $type TFun([],TType(js.Image,[]))
 * private function getNewImage()
 * @private
 * @this com.inq.ui.Container
 * @return {Node} - image object with the correct document as the owner.
 */
com.inq.ui.Container.prototype.getNewImage = function() {
	/** @type {HTMLImageElement} */
	var newImage = new Image();
	/** @type {Document} */
	var doc = newImage.ownerDocument;
	/* Get the owner document of the image */
	/** @type {Document} */
	var containerDoc = this._div.ownerDocument;
	/* Get the owner document of the containing DIV */
	if (doc != this.document) {
		try {
			if (!!containerDoc["importNode"]) {
				return containerDoc.importNode(newImage, false);
			}
		} catch (e) {
			haxe.Log.trace("New image could not be imported: " + Std.string(e), {
				fileName: "Container.hx",
				lineNumber: 1393,
				className: "com.inq.ui.Container",
				methodName: "getNewImage"
			});
		}
	}
	/* If the documents are not the same, then import the node into the document */
	return newImage;
};


/**
 * getIsSprite - private function that determins if the image is a sprite or a true full image
 *
 * $type TFun([],TDynamic(null))
 * private function getIsSprite():Dynamic
 * @private
 * @this com.inq.ui.Container
 * @return {null} - true/false
 */
com.inq.ui.Container.prototype.getIsSprite = function() {
	if(this._isSprite == null) this._isSprite = !(null == this.getStyle("sprite-width") && null == this.getStyle("sprite-height") && null == this.getStyle("sprite-left") && null == this.getStyle("sprite-top"));
	return this._isSprite;
};


/**
 * loadContent
 *
 * $type TFun([],TEnum(Void,[]))
 * public function loadContent():Void
 * @public
 * @this com.inq.ui.Container
 * @return {void}
 */
com.inq.ui.Container.prototype.loadContent = function() {
	if (this.contains) {
		this.contains.forEach(function(child) {
			if (child) {
				child.loadContent();
			}
		});
	}
};


/**
 * renderCanvas - renders the image from the image object to the canvas
 * The image object's visibility is "none" and therefor it is not seen
 * The canvas shows the image's image, but not the entire image, just a viewport of the image.
 *
 * $type TFun([{ name => canvas, t => TDynamic(null), opt => false }],TEnum(Void,[]))
 * private function renderCanvas(canvas:Dynamic):Void
 * @private
 * @this com.inq.ui.Container
 * @param {HTMLElement} canvas to receive the image view
 * @return {void}
 */
com.inq.ui.Container.prototype.renderCanvas = function(canvas) {
	if(!!canvas.sourceImage) {
		/** @type {?CanvasRenderingContext2D} */
		var context = null;
		/* First make the canvas size the same as the image size
		 * This way, when the div is stretched, the image will stretch as well.
		 *
		 * Let's explain that some more,
		 * The canvas size attribute will be the size of the sprite width and height
		 * The canvas size style will be the size of the entire containing div and will stretch the canvas image
		 */

		canvas.height = canvas.spriteHeight;
		canvas.width = canvas.spriteWidth;
		canvas.style.position = "absolute";
		/** @type {HTMLImageElement} */
		var imageElement = canvas.sourceImage;/* Get the source image from the canvas, it was put in the canvas in the "whenLoaded" method */

		/* Size the canvas in the style, not in the attribute, the attribute MUST have the correct width and height from the sprite */
		canvas.style.top = "0px";
		canvas.style.bottom = "";
		canvas.style.left = "0px";
		canvas.style.right = "";
		canvas.style.width = "" + Std.string(canvas.spriteWidth) + "px";
		canvas.style.height = "" + Std.string(canvas.spriteHeight) + "px";

		/* Get the "context" from the canvas and draw the image from the large sprite image */
		context = canvas.getContext("2d");
		context.drawImage(imageElement,canvas.spriteLeft,canvas.spriteTop,canvas.spriteWidth,canvas.spriteHeight,0,0,canvas.spriteWidth,canvas.spriteHeight);

		/** @type {number} */
		var dh = canvas.spriteHeight;
		/** @type {number} */
		var dw = canvas.spriteWidth;

		/* If the container style has no height, then we will:
		 * 1) use the bottom and top setting to calculate the height
		 * 2) or we use 100% for the height, to fill the div container
		 */
		if(this.getStyle("height") == null) {
			if(this.getStyle("bottom") != null && this.getStyle("top") != null) {
				/** @type {string} */
				var bot = "" + this.evaluatePosition(this.getStyle("bottom"));
				/** @type {string} */
				var top = "" + this.evaluatePosition(this.getStyle("top"));
				canvas.style.bottom = canvas.style.top = "0px";
				canvas.style.height = "100%";
				dh = this._div.clientHeight;
			} else dh = this.calculateHeight();
		}

		/* if we have a zero height, then use the sprite height as the default */
		if(dh == 0) dh = canvas.spriteHeight;

		/* If the container style has no width, then we will:
		 * 1) use the right and left setting to calculate the width
		 * 2) or we use 100% for the width, to fill the div container
		 */
		if(this.getStyle("width") == null) {
			if(this.getStyle("right") != null && this.getStyle("left") != null) {
				/** @type {string} */
				var rgt = "" + this.evaluatePosition(this.getStyle("right"));
				/** @type {string} */
				var lft = "" + this.evaluatePosition(this.getStyle("left"));
				canvas.style.right = canvas.style.left = "0px";
				canvas.style.width = "100%";
				dw = this._div.clientWidth;
			} else dw = this.calculateWidth();
		}

		/* if we have a zero width, then use the sprite width as the default */
		if(dw == 0) dw = canvas.spriteWidth;

		context = canvas.getContext("2d");
		context.drawImage(imageElement,canvas.spriteLeft,canvas.spriteTop,canvas.spriteWidth,canvas.spriteHeight,0,0,dw,dh);

		canvas.style.width = "100%";
		canvas.style.height = "100%";
	} else haxe.Log.trace("Canvas source image is missing",{ fileName : "Container.hx", lineNumber : 1354, className : "com.inq.ui.Container", methodName : "renderCanvas"});
};


/**
 * calculateHeight - calculates the height of the container using the bottom and top settings
 *
 * $type TFun([],TInst(Int,[]))
 * private function calculateHeight():Int
 * @private
 * @this com.inq.ui.Container
 * @return {number} - integer containing the height in pixels.
 */
com.inq.ui.Container.prototype.calculateHeight = function() {
	/** @type {number} */
	var top = this.evaluatePosition(this.getStyle("top"));
	/** @type {number} */
	var bottom = this.evaluatePosition(this.getStyle("bottom"));
	/** @type {number} */
	var height = this._div.clientHeight;
	height -= bottom - top;
	return height > 0?height:0;
};


/**
 * calculateWidth - calculates the width of the container using the right and left settings
 *
 * $type TFun([],TInst(Int,[]))
 * private function calculateWidth():Int
 * @private
 * @this com.inq.ui.Container
 * @return {number} - integer containing the width in pixels.
 */
com.inq.ui.Container.prototype.calculateWidth = function() {
	/** @type {number} */
	var left = this.evaluatePosition(this.getStyle("left"));
	/** @type {number} */
	var right = this.evaluatePosition(this.getStyle("right"));
	/** @type {number} */
	var width = this._div.clientWidth;
	width -= right - left;
	return width > 0?width:0;
};


/**
 * findChild
 * find child div by its id
 *
 * public function findChild(childId : String):Dynamic
 * @public
 * @this com.inq.ui.Container
 * @param {string}  childId -  child id
 * @return {null} - child div if there is, or null
 */
com.inq.ui.Container.prototype.findChild = function(childId) {
	for (var i = 0; i < this.contains.length; i++) {
		var child = this.contains[i];
		if(child && child._div) {
			if(child._div.id == childId) return child;
		}
	}
	return null;
};

/**
 * Returns the list of child containers for current instance.
 * @returns {Array}
 */
com.inq.ui.Container.prototype.getChildren = function() {
	return this.contains;
};

/**
 * setScrolling -
 * This is a dummy function that gets overloaded in super classes
 * such as IFRAME and XFRAME
 *
 * param val - value of the scrolling attribute
 *
 * $type TFun([{ name => val, t => TDynamic(null), opt => false }],TDynamic(null))
 * private function setScrolling(val:Dynamic):Dynamic
 * @private
 * @this com.inq.ui.Container
 * @param {null}  val
 * @return {null}
 */
com.inq.ui.Container.prototype.setScrolling = function(val) {
};


/**
 * we need this function for XFrame.hx
 * --------------------- *
 *
 * $type TFun([{ name => val, t => TInst(String,[]), opt => true }],TEnum(Void,[]))
 * public function updateSrc(?val:String):Void
 * @public
 * @this com.inq.ui.Container
 * @param {string}  val -  optional parameter
 * @param initiator initiator who show automaton
 * @return {void}
 */
com.inq.ui.Container.prototype.updateSrc = function(val, initiator) {
	if (this.contains) {
		this.contains.forEach(function(child) {
			if (child) {
				child.updateSrc(val, initiator);
			}
		});
	}
};


/**
 * setSrc
 *
 * $type TFun([{ name => val, t => TDynamic(null), opt => false }],TDynamic(null))
 * private function setSrc(val:Dynamic):Dynamic
 * @private
 * @this com.inq.ui.Container
 * @param {null}  val
 * @return {null}
 */
com.inq.ui.Container.prototype.setSrc = function(val) {
};

/**
 * Find iFrame in container and replace src property with the given paramter.
 *
 * @param {String} url iFrame src URL
 */
com.inq.ui.Container.prototype.setIFrameSrc = function(url) {
	var targetIframes = this._div.getElementsByTagName("iframe");
	var targetIframe = targetIframes && (targetIframes.length > 0 ? targetIframes[0] : null);
	if (targetIframe) {
		targetIframe.src = url;
	}
};

/**
 * removeFrom - remove child node from parent container
 *
 * public function removeFrom(?parentContainer:Container)
 * @public
 * @this com.inq.ui.Container
 * @param {com.inq.ui.Container}  parentContainer - Optional parent of this container
 * @return {void}
 */
com.inq.ui.Container.prototype.removeFrom = function(parentContainer) {
	if(parentContainer == null) parentContainer = this.parent;
	if(parentContainer != null) {
		parentContainer._div.removeChild(this._div);
		if(parentContainer.contains == null) return;
		for (var i = 0; i < parentContainer.contains.length; i++) {
			if (parentContainer.contains[i] == this) {
				parentContainer.contains[i] = null;
			}
		}
		while(parentContainer.contains.length > 0 && parentContainer.contains[parentContainer.contains.length - 1] == null) parentContainer.contains.pop();
	}
};


/**
 * attachTo - attach child node to parent container
 *
 * $type TFun([{ name => parentContainer, t => TInst(com.inq.ui.Container,[]), opt => false },{ name => after, t => TInst(com.inq.ui.Container,[]), opt => true }],TEnum(Void,[]))
 * public function attachTo(parentContainer:Container, ?after:Container):Void
 * @public
 * @this com.inq.ui.Container
 * @param {com.inq.ui.Container}  parentContainer - Container that is to be the parent of this container
 * @param {com.inq.ui.Container}  after - optional child to be placed after
 * @return {void}
 */
com.inq.ui.Container.prototype.attachTo = function(parentContainer,after) {
	/** @type {HTMLElement} */
	var ob = parentContainer._div;
	/** @type {HTMLElement} */
	var obSibling = after != null ? after._div : null;
	if(!js.Boot.__instanceof(parentContainer,com.inq.ui.ClientBody)) {
		if(parentContainer.contains == null) parentContainer.contains = new Array();
		if(this._div.id != com.inq.ui.Container.SC_TITLEBAR && this._div.id != com.inq.ui.Container.SC_RESIZE && this._div.id != "tcChat_Skin") parentContainer.contains[parentContainer.contains.length] = this;
	}
	this.attachToElement(ob,obSibling);
	this.parent = parentContainer;
	this._clientStage = parentContainer._clientStage;
};


/**
 * attachToElement - attach child node to parent node
 *
 * $type TFun([{ name => ob, t => TDynamic(null), opt => false },{ name => after, t => TDynamic(null), opt => true }],TEnum(Void,[]))
 * public function attachToElement(ob:Dynamic, ?after:Dynamic):Void
 * @public
 * @this com.inq.ui.Container
 * @param {null}  ob - object to be parent object
 * @param {null}  after - optional child to be placed after
 * @return {void}
 */
com.inq.ui.Container.prototype.attachToElement = function(ob,after) {
	this._parent = ob;
	if(this._div.parentNode != null && this._div.parentNode.nodeName.indexOf("#") != 0) return;

	if(null != this.styles["id"]) this.setID(this.styles["id"]);

	try {
		if (after == null) {
			ob.appendChild(this._div);
		} else if (after.nextSibling == null) {
			ob.appendChild(this._div);
		} else {
			ob.insertBefore(this._div, after.nextSibling);
		}
	} catch( e ) {
		if( js.Boot.__instanceof(e,Error) ) {
			haxe.Log.trace("ERROR: " + Std.string(e),{ fileName : "Container.hx", lineNumber : 1153, className : "com.inq.ui.Container", methodName : "attachToElement"});
		} else throw(e);
	}
};


/**
 * resizer
 *
 * public function resizer(cntns:Array<Dynamic>):Void
 * @public
 * @this com.inq.ui.Container
 * @param {Array}  cntns
 * @return {void}
 */
com.inq.ui.Container.prototype.resizer = function(cntns) {
	if(cntns == null || cntns.length == 0) return;
	for (var i = 0; i < cntns.length; i++) {
		try {
			var o = cntns[i];
			if(o == null) continue;
			o.resize();
			if(o.contains != null && o.contains.length > 0) this.resizer(o.contains);/*  do it's children as well ;*/
		} catch( e ) {
			if( js.Boot.__instanceof(e,Error) ) {
			} else throw(e);
		}
	}
};


/**
 * resize
 *
 * public function resize()
 * @public
 * @this com.inq.ui.Container
 * @return {void}
 */
com.inq.ui.Container.prototype.resize = function() {
	this.applyStyle();

	/*
	* That is a workaround to restore "font-size" property for "div" elements in the "email" panel,
	* because we reset all styles that were set for the "div" elements when we use "setVisible" method and
	* set properties which are kept in the parsed elements in the "Application.application".
	*
	* It's necessary to refactor "FontMgr" to use elements from "Application.application" and remove it.
	*/
	if (this.getVisible()) {
		com.inq.flash.client.chatskins.FontMgr.restoreFontSizeForEmailPanel(this._div);
	}
};


/**
 * applyStyle - is used to calculate styles and add its to the HTMLElements of the current component.
 */
com.inq.ui.Container.prototype.applyStyle = function() {
	this.buildStyle();
	if(this._div != null) {
		this._div.style.cssText = this._style;
		this.fixContainerSize();
	}
};

/**
 * fixContainerSize - is used to adjust the height and width for the size of the borders
 */
com.inq.ui.Container.prototype.fixContainerSize = function () {
	var self = this;

	if (!com.inq.utils.Util.isBorderBoxEnabled(this._div)) {
		if (borderWidths() > 0) {
			setNewElementWidth();
		}

		if (borderHeights() > 0) {
			setNewElementHeight();
		}

		/** @returns {number} */
		function borderWidths () {
			var borderLeftWidth = parsePixelValue(self._div.style.borderLeftWidth);
			var borderRightWidth = parsePixelValue(self._div.style.borderRightWidth);
			return borderLeftWidth + borderRightWidth;
		}

		function setNewElementWidth () {
			var elementWidth = parsePixelValue(self._div.style.width);
			var adjustedWidth = Math.max(elementWidth - borderWidths(), 0);

			self._div.style.width = adjustedWidth + "px";
		}

		/** @returns {number} */
		function borderHeights () {
			var borderTopWidth = parsePixelValue(self._div.style.borderTopWidth);
			var borderBottomWidth = parsePixelValue(self._div.style.borderBottomWidth);
			return borderTopWidth + borderBottomWidth;
		}

		function setNewElementHeight () {
			var elementHeight = parsePixelValue(self._div.style.height);
			var adjustedHeight = Math.max(elementHeight - borderHeights(), 0);

			self._div.style.height = adjustedHeight + "px";
		}

		/**
		 * Converts a CSS pixel size string to number, defaults to 0
		 * @param   {string} pixelValueString	example "20px"
		 * @returns {number}
		 */
		function parsePixelValue (pixelValueString) {
			if (pixelValueString) {
				return Std.parseInt(pixelValueString);
			}

			return 0;
		}
	}
};

/**
 * evaluateString - takes symbolic values in the MXML and parses them into string value.  The symbolic references are in the syntax of {id.value}
 * The string starts and ends with {} and the symbolic values are also encased in {}
 * The symbolic values are parsed from the FlashVars, the client Window, or from the Client Document
 * If the symbolic value is undefined, it is replaced by an empty string
 *
 * examples:
 * {{FlashVars.chatID}}						results in "000105020201" or whatever the chat id is
 * {{Window.name}}								results in the name of the window as a string
 * {{Window.location.href}}					results in the client window's URL as a string
 * {Agent's name is {FlashVars.agentName}}		results in "Agent's name is Jessica"
 * {{InputField.first_name} {InputField.last_name} phone: {InputField.phone}}
 * produces "Fred Pinn, phone: 888 555 1111" where the values are retrieved from form fields with the
 * ids of "first_name" "last_name" and "phone".  As in our "http://www.touchcommerce.com/Contact/" page
 *
 * $type TFun([{ name => value, t => TInst(String,[]), opt => false }],TInst(String,[]))
 * public function evaluateString(value:String):String
 * @public
 * @this com.inq.ui.Container
 * @param {string}  value - Position as a string, it can contain references relative to other containers' position
 * @return {string} - The position evaluated from "value" as a string
 */
com.inq.ui.Container.prototype.evaluateString = function(value) {
	try {
		value = StringTools.trim(value);
		if(value.charAt(0) == "{") {
			/* Remove the bounding "{...}" */
			/** @type {string} */
			var origValue = value;
			try {
				/** @type {number} */
				var ix = value.lastIndexOf("}");
				if(ix == -1) throw "Curly Braces not balanced";

				value = HxOverrides.substr(value,1,ix - 1);
				/* Let's get all the symbolic values, via a regexp */
				/** @type {EReg} */
				var rSym = new EReg("{([a-zA-Z_][a-zA-Z0-9_]*[.][a-zA-Z_][a-zA-Z.0-9_]*)}","m");
				/** @type {string} */
				var sym;
				while(rSym.match(value)) {
					try {
						sym = rSym.matched(1);
					} catch( e ) {
						break;
					}
					/** @type {string} */
					var val = com.inq.ui.CommandParser.evaluateSymbolicReference(sym);
					value = rSym.matchedLeft() + val + rSym.matchedRight();
				}
				return value;
			} catch( e ) {
				haxe.Log.trace("Error evaluating '" + origValue + "' to '" + value + "': " + Std.string(e),{ fileName : "Container.hx", lineNumber : 1068, className : "com.inq.ui.Container", methodName : "evaluateString", customParams : [e]});
			}
			return "";
		} else return value;
	} catch( e ) {
		haxe.Log.trace("parse error: " + Std.string(e),{ fileName : "Container.hx", lineNumber : 1076, className : "com.inq.ui.Container", methodName : "evaluateString", customParams : [e]});
	}
	return "";
};


/**
 * evaluatePosition - takes symbolic values in the MXML and parses them int an integer value.
 * Since there are no such thing as pixel fractions, we will round the value to an integer
 *
 * @INFO Using eval function in this function is safe because in #evaluatePosition function we are trying to convert
 * all the values that we receive into numbers and only after that we pass the ready expression to the eval function.
 * If we will catch some unknown expression we will stop our #evaluatePosition function and not pass any values to the
 * eval function.
 *
 * examples:
 * {chat.top}
 * {chat.top + 5}
 * {xforms1.height + xforms2.height}
 *
 * $type TFun([{ name => value, t => TInst(String,[]), opt => false }],TInst(Int,[]))
 * public function evaluatePosition(value:String):Int
 * @public
 * @this com.inq.ui.Container
 * @param {string}  value - Position as a string, it can contain references relative to other containers' position
 * @return {number} - The position evaluated from "value" as an integer
 */
com.inq.ui.Container.prototype.evaluatePosition = function(value) {
	if (value) {
		try {
			value = StringTools.trim(value);
			if (value.charAt(0) == "{") {
				/* Remove the bounding "{...}" */
				try {
					/** @type {number} */
					var ix = value.lastIndexOf("}");
					if (ix == -1) throw "Curly Braces not balanced";

					value = HxOverrides.substr(value, 1, ix - 1);
					/* Let's get all the symbolic values, via a regexp */
					/** @type {EReg} */
					var rSym = new EReg("([a-z][a-z.0-9]*)", "im");
					/** @type {string} */
					var sym;
					while (rSym.match(value)) {
						try {
							sym = rSym.matched(1);
						}
						catch (e) {
							break;
						}
						/** @type {string} */
						var val = com.inq.ui.CommandParser.evaluateSymbolicReference(sym);
						value = rSym.matchedLeft() + val + rSym.matchedRight();
					}

					try {
						var ret;
						if (com.inq.flash.client.control.FlashPeer.isPolishNotationEnabled()) {
							/** @type {number} */
							ret = com.inq.utils.Util.evalExpression(value);
						} else {
							ret = com.inq.flash.client.control.FlashPeer.evaluateLegacySettings(value);
						}
					} catch (e) {
						haxe.Log.trace("Container#evaluatePosition Invalid attr value");
					}

					if ("Infinity" == "" + ret) throw "Divide by zero error";
					return Math.round(ret) | 0;
					/* Since there are no such thing as pixel fractions, we will round the value to an integer*/
				}
				catch (e) {
				}
				return 0;
			}
			else {
				return Std.parseInt(value);
			}
		}
		catch (e) {
			haxe.Log.trace("parse error: " + Std.string(e), {
				fileName: "Container.hx",
				lineNumber: 1019,
				className: "com.inq.ui.Container",
				methodName: "evaluatePosition",
				customParams: [e]
			});
		}
	}
	return 0;
};

/**
 * getParentHeight - checked the parent height value and returns its correct value
 * for IE8 and compatible IE8 mode.
 *
 * @this {com.inq.ui.Container}
 * @return {number} - height of the HTMLParentElement
 */
com.inq.ui.Container.prototype.getParentHeight = function() {
	/** @type {number} */
	var h = this._parent.clientHeight;
	/*
	 * According to the issue RTDEV-3184:
	 * for IE8 we need to correct the calculation of the container height because
	 * this browser sometimes returns incorrect value of clientHeight property for BODY element.
	 * More detail this described in the ticket RTDEV-3184.
	 */
	/** @type {boolean} */
	var isIE = window.navigator.userAgent.indexOf("MSIE") != -1 || window.navigator.userAgent.indexOf("Trident") != -1;
	if (isIE && this instanceof Application
		//additional conditions
		&& this._parent != null
		&& this._parent.id != "Skin") {
		/** @type {number} */
		var docHeight = document.documentElement.clientHeight;
		if (h != docHeight) {
			h = docHeight;
		}
	}
	return h;
};

/**
 * Adds the string of definition of the style property to the single string to add
 * all styles on the element simultaneously through property cssText.
 *
 * @param {string} property
 * @param {string} value
 */
com.inq.ui.Container.prototype.addCssTextProperty = function(property, value) {
	this._style += this.createCssText(property, value);
};

/**
 * Creates the string of definition of the style property, e.g.:
 *  "font-size: 12px;"
 *
 * @param {string} property
 * @param {string} value
 * @return {string}
 */
com.inq.ui.Container.prototype.createCssText = function(property, value) {
	if (/[A-Z]/.test(property)) {
		property = property.replace(/([A-Z])/g, function(match){return "-" + match.toLowerCase()});
	}
	return property + ": " + value + ";";
};

/**
 * buildCssText
 *
 * Create the string like the "cssText" to update all styles of the element simultaneously.
 *
 * @private
 * @this com.inq.ui.Container
 * @param {string} initStyle - string of styles for initialize
 * @return {string}
 */
com.inq.ui.Container.prototype.buildCssText = function(initStyle, clientElement) {
	/** @type {string} */
	var width = this.styles["width"];
	/** @type {string} */
	var left = this.styles["left"];
	/** @type {string} */
	var top = this.styles["top"];
	/** @type {string} */
	var height = this.styles["height"];
	/** @type {string} */
	var right = this.styles["right"];
	/** @type {string} */
	var bottom = this.styles["bottom"];

	var pw;
	var ph;

	/* We want Application stage to be equal to the size of the frameElement
	 * The frameElement is the IJSF IFrame.
	 */
	if (js.Boot.__instanceof(this, Application)) {
		if(com.inq.flash.client.control.FlashPeer.noV3FrameChat()) {
			pw = Std.parseInt(Application.application.stg.style.width);
			ph = Std.parseInt(Application.application.stg.style.height);
		} else {
			pw = Std.parseInt(window.frameElement.style.width);
			ph = Std.parseInt(window.frameElement.style.height);
		}
	} else {
		pw = this._parent == null ? width : this._parent.clientWidth;
		ph = this._parent == null ? height : this.getParentHeight();

		/* RTDEV-24911 UPS has a dynamic div which Chat Window is populated. On page reload, a Skin div doesn't provide
		*  clientWidth correctly but 1 while style attribute contains correct size.
		*  So the condition below checks if this is the case, then use size from style value. */
		if (com.inq.flash.client.control.FlashPeer.isEmbeddedThemeValid()
			&& this._parent != null && this._parent.id === "tcChat_Skin"
			&& (pw < 10 || ph < 10)
			&& (com.inq.utils.Util.isIE || com.inq.utils.Capabilities.isSafari())
		) {
			pw = ( pw < 10 && this._parent.style.width.indexOf("px") != -1 ) ? this._parent.style.width.slice(0, -2) : pw;
			ph = ( ph < 10 && this._parent.style.height.indexOf("px") != -1 ) ? this._parent.style.height.slice(0, -2) : ph;
		}
	}

	if (null != width && com.inq.ui.Container.isString(width) && "%" == HxOverrides.substr(width, width.length - 1, null)) {
		width = "" + this.evaluatePosition(width) * pw / 100;
	}
	if (null != height && com.inq.ui.Container.isString(height) && "%" == HxOverrides.substr(height, height.length - 1, null)) {
		height = "" + this.evaluatePosition(height) * ph / 100;
	}

	if (null == height && this._div != null) {
		height = Std.string(Math.max(this._div.clientHeight, 0));
	}
	if (null == width && this._div != null) {
		width = Std.string(Math.max(this._div.clientWidth, 0));
	}

	if (left != null && right != null) {
		left = "" + this.evaluatePosition(left);
		width = "" + Math.max(pw - this.evaluatePosition(right) - this.evaluatePosition(left), 0);
	} else if (left != null && right == null) {
		left = "" + this.evaluatePosition(left);
	} else if (left == null && right != null) {
		left = "" + (pw - (this.evaluatePosition(right) + this.evaluatePosition(width)));
	}
	if (top != null && bottom != null) {
		top = "" + this.evaluatePosition(top);
		height = "" + Math.max(ph - this.evaluatePosition(bottom) - this.evaluatePosition(top), 0);
	} else if (top != null && bottom == null) {
		top = "" + this.evaluatePosition(top);
	} else if(top == null && bottom != null) {
		top = "" + (ph - (this.evaluatePosition(bottom) + this.evaluatePosition(height)));
	}

	// Embedded chat should not have left and/or top
	if (this._div != null && this._div.id === "tcChat_Skin"
		&& com.inq.flash.client.control.FlashPeer.isEmbeddedThemeValid()) {
		top = 0;
		left = 0;
	}

	this._style = initStyle || "";

	this.addCssTextProperty("z-index", this.styles["zIndex"] || "101");

	if (this.styles["visibility"] == "collapse") {
		if (left != null && !clientElement) {
			this.addCssTextProperty("left", com.inq.ui.Container.encodeSize(left));
		}
		if (top != null && !clientElement) {
			this.addCssTextProperty("top", com.inq.ui.Container.encodeSize(top));
		}

		// we should set property "visibility:collapse" at the end of css text string,
		// because otherwise, when we set the other property (e.g. size or position),
		// it becomes "visibility:visible"
		this._style += "height:0px;width:0px;display:none;visibility:collapse";

		return this._style;
	}

	/** @type {string} */
	var styleValue = "";
	for (var keyname in this.styles) {
		if (!this.styles.hasOwnProperty(keyname) || "backgroundSize" == keyname) {
			continue;
		}

		styleValue = this.styles[keyname];

		if ("backgroundImage" == keyname && styleValue != null) {
			if (this.styles["backgroundSize"] == "100%") {
				if (height != null && height.length > 0 && height.indexOf("%") == -1) {
					height = parseInt(height) >= 0 ? height : "0";
				}
				if (width != null && width.length > 0 && width.indexOf("%") == -1) {
					width = parseInt(width) >= 0 ? width : "0";
				}
				if (width != null) {
					this._backgroundImage.style.width = com.inq.ui.Container.encodeSize(width);
				}
				if (height != null) {
					this._backgroundImage.style.height = com.inq.ui.Container.encodeSize(height);
				}
			} else {
				if (this._backgroundImage) {
					this._backgroundImage.style.width = this._backgroundImage.style.height = "0px";
				}
				this.addCssTextProperty("background-image", "url('" + this.styles["backgroundImage"] + "')");
			}
			continue;
		}

		switch (keyname) {
			case "height":
			case "width":
			case "top":
			case "bottom":
			case "left":
			case "right":
				if (this._clientStage) {
					this.addCssTextProperty(keyname, com.inq.ui.Container.encodeSize(styleValue));
				} else if (clientElement) {
					if ((keyname == "top" && !this.styles["bottom"])
						|| (keyname == "left" && !this.styles["right"])
					) {
						this.addCssTextProperty(keyname, com.inq.ui.Container.encodeSize(this.evaluatePosition(styleValue)));
					}
				}
				break;

			case "margin-left":
				if (clientElement) {
					this.addCssTextProperty("left", com.inq.ui.Container.encodeSize(this.evaluatePosition(styleValue)));
				} else {
					this.addCssTextProperty(keyname, com.inq.ui.Container.encodeSize(styleValue));
				}
				break;
			case "margin-right":
				if (clientElement) {
					this.addCssTextProperty("right", com.inq.ui.Container.encodeSize(this.evaluatePosition(styleValue)));
				} else {
					this.addCssTextProperty(keyname, com.inq.ui.Container.encodeSize(styleValue));
				}
				break;

			case "color":
			case "cursor":
			case "backgroundColor":
			case "background-color":
			case "borderColor":
			case "border-color":
			case "borderStyle":
			case "border-style":
			case "fontFamily":
			case "textAlign":
			case "text-align":
			case "verticalAlign":
				this.addCssTextProperty(keyname, styleValue);
				break;

			case "alpha":
				this.addCssTextProperty("filter", "alpha(opacity=" + styleValue + ")");
				this.addCssTextProperty("-moz-opacity", "0." + styleValue); // FF before version 3.5
				this.addCssTextProperty("opacity", "0." + styleValue);
				break;

			case "border-width":
			case "borderThickness":
			case "border-thickness":
				this.addCssTextProperty("border-width", com.inq.ui.Container.encodeSize(styleValue));
				break;

			case "border-thickness-left":
				this.addCssTextProperty("border-left-width", com.inq.ui.Container.encodeSize(styleValue));
				break;
			case "border-thickness-right":
				this.addCssTextProperty("border-right-width", com.inq.ui.Container.encodeSize(styleValue));
				break;
			case "border-thickness-top":
				this.addCssTextProperty("border-top-width", com.inq.ui.Container.encodeSize(styleValue));
				break;
			case "border-thickness-bottom":
				this.addCssTextProperty("border-bottom-width", com.inq.ui.Container.encodeSize(styleValue));
				break;

			case "border-radius":
				this.addCssTextProperty("-moz-border-radius", com.inq.ui.Container.encodeSize(styleValue));
				this.addCssTextProperty("-webkit-border-radius", com.inq.ui.Container.encodeSize(styleValue));
				this.addCssTextProperty("border-radius", com.inq.ui.Container.encodeSize(styleValue));
				break;

			case "fontSize":
				this.addCssTextProperty("font-size", com.inq.ui.Container.encodeSize(styleValue, "pt"));
				break;

			case "backgroundGradientColors":
				/** @type {string} */
				var bc = HxOverrides.substr(styleValue, 1, styleValue.length - 2);
				/** @type {Array} */
				var bca = bc.split(",");
				this.addCssTextProperty("background-color", bca[0]);
				break;

			case "visible":
				this.addCssTextProperty("display", styleValue == "true" ? "block" : "none");
				break;

			default:
				if (keyname.indexOf(":") == -1
						&& typeof styleValue == "string"
						&& styleValue.indexOf(":") == -1
						&& styleValue.indexOf(";") == -1
						&& styleValue.indexOf("@") == -1
				) {
					this.addCssTextProperty(keyname, styleValue);
				}
		}
	}

	if ((this.styles.id === "tc-aria-readme" || this.styles.id === "tcChat_tc-aria-readme")
		&& (width == null || width === "0")
	) {
		width = "1px";
	}

	if (left != null && !clientElement) {
		this.addCssTextProperty("left", com.inq.ui.Container.encodeSize(left));
	}
	if (top != null && !clientElement) {
		this.addCssTextProperty("top", com.inq.ui.Container.encodeSize(top));
	}

	if (height != null && height != "0") {
		this.addCssTextProperty("height", com.inq.ui.Container.encodeSize(height));
	}
	if (width != null && width != "0") {
        if(navigator.userAgent.indexOf("iPhone OS 10_3") >= 0 && com.inq.utils.Capabilities.getOrientation()) {
            if(!com.inq.ui.Container.MaxWidth) {
                viewPort = com.inq.utils.Capabilities.getViewport();
                com.inq.ui.Container.MaxWidth = viewPort.w;
            }
            if(com.inq.ui.Container.MaxWidth && width > com.inq.ui.Container.MaxWidth) {
                width = com.inq.ui.Container.MaxWidth;

            }
        }
		this.addCssTextProperty("width", com.inq.ui.Container.encodeSize(width));
	}

	return this._style;
};

/**
 * buildStyleOriginal
 *
 * private function buildStyleOriginal():Void
 * @private
 * @this com.inq.ui.Container
 * @return {void}
 *
 * @deprecated
 */
com.inq.ui.Container.prototype.buildStyleOriginal = function() {
	this.buildNewStyle();
};

/**
 * buildChatElementStyle
 *
 * private function buildChatElementStyle():Void
 * @private
 * @this com.inq.ui.Container
 * @return {void}
 *
 * @deprecated
 */
com.inq.ui.Container.prototype.buildChatElementStyle = function() {
	this.buildNewStyle();
};

/**
 * buildNewStyle
 *
 * private function buildNewStyle():Void
 * @private
 * @this com.inq.ui.Container
 * @return {void}
 */
com.inq.ui.Container.prototype.buildNewStyle = function() {
	if (this._div != null && this._div.id == com.inq.ui.Container.SC_SKIN && com.inq.flash.client.control.FlashPeer.isEmbeddedThemeValid()) {
		//The position is always 'relative' to it's container div for embedded chats
		this._style = this.buildCssText("position: relative; overflow: hidden;");
	} else {
		this._style = this.buildCssText("position: absolute; overflow: hidden;");
	}
	com.inq.ui.Container.MaxWidth = null;
};


/**
 * fixCssClasses
 *
 * private function fixCssClasses()
 * @private
 * @this com.inq.ui.Container
 * @return {void}
 */
com.inq.ui.Container.prototype.fixCssClasses = function() {
	if (this._div) {
		/** @type {NodeList} */
		var children = this._div.getElementsByTagName("*");
		for (var i = 0; i < children.length; i++) {
			try {
				this.addCssClass(children[i]);
			} catch(e){}

		}
	}
};


/**
 * addCssClass - this code has been refactored from fixCssClasses
 * it is now used by the constructor and by the fixCssClasses
 *
 * If we are the document body (that is the document body of the client area, we do not want to add our class
 * We also do not want to add our class to elements that do not have our prefix in it,
 * such as:
 * inq*
 * tcChat_*
 *
 * private function addCssClass(element:HtmlDom)
 * @private
 * @this com.inq.ui.Container
 * @param {HTMLElement} element
 * @return {void}
 */
com.inq.ui.Container.prototype.addCssClass = function(element) {
	if (element == null
		|| element.nodeName.toUpperCase() == "BODY"
		|| element.id == null
		|| element.id == ""
		|| (element.id.indexOf(com.inq.ui.Container.CLIENT_SPACE_PREFIX) != 0 && element.id.indexOf(com.inq.ui.Container.LEGACY_PREFIX) != 0)) {
		return;
	}

	if (element.className == null || element.className == "") {
		element.className = com.inq.ui.Container.CHAT_CLASS;
	} else if (element.className.indexOf(com.inq.ui.Container.CHAT_CLASS) == -1) {
		element.className += " " + com.inq.ui.Container.CHAT_CLASS;
	}
};


/**
 * buildStyle
 *
 * private function buildStyle():Void
 * @private
 * @this com.inq.ui.Container
 * @return {void}
 */
com.inq.ui.Container.prototype.buildStyle = function() {
	if(com.inq.utils.Capabilities._isWebKit() && com.inq.ui.SkinLoader.skinInClient || com.inq.ui.SkinLoader.hasClientBody) {
		this.fixCssClasses();
		if (this.parent != null && js.Boot.__instanceof(this.parent, com.inq.ui.ClientBody)) {
			this.buildClientElementStyle();
		}
		else {
			this.buildNewStyle();
		}
	} else {
		this.buildNewStyle();
	}
};


/**
 * buildClientElementStyle
 *
 * private function buildClientElementStyle():Void
 * @private
 * @this com.inq.ui.Container
 * @return {void}
 */
com.inq.ui.Container.prototype.buildClientElementStyle = function() {
	this._style = this.buildCssText("", true);
};


/**
 * setVisible
 * visible setter
 * sets the visibility for the container
 *
 * $type TFun([{ name => val, t => TDynamic(null), opt => false }],TEnum(Void,[]))
 * private function setVisible(val:Dynamic):Void
 * @private
 * @this com.inq.ui.Container
 * @param {null}  val - set to true or false, it will accept a boolean true or false or a string "true" or "false"
 * @return {void}
 */
com.inq.ui.Container.prototype.setVisible = function(val) {
	try {
		this._visible = !("false" == val || null == val || false == val);
		if(this._visible)
			this.fireVisible();
		else
			this.fireHidden();
		/** @type {boolean} */
		var _isPersistent = com.inq.flash.client.control.FlashPeer.isPersistentWindow();
		if(this._div != null
			&& (this._div.id == com.inq.ui.Container.SC_RESIZE || this._div.id == com.inq.ui.Container.SC_TITLEBAR)
			&& (_isPersistent || com.inq.flash.client.control.FlashPeer.isEmbeddedThemeValid())) {
			this._visible = false;
			this._div.style.cssText = "display: none;";
			return;
		}
		this.styles["visible"] = this._visible?"true":"false";
		/* If there is no parent container, hide the container via the display style
		 * This is for the corner resizer and the drag bar
		 * They are outside the skin and have no parent container.
		 */
		if(this.parent == null && this._div != null) {
			this._div.style.display = this._visible?"":"none";
			return;
		}
		this.resize();
		this.resizer(this.contains);

	} catch( e ) {
	}
};

/**
 * fireVisible fires the onVisible event listeners on the container
 * @public
 */
com.inq.ui.Container.prototype.fireVisible = function() {
	com.inq.ui.CommandParser.executeLogic(this.styles["onVisible"], false, this);
};

/**
 * fireHidden fires the onHidden event listeners on the container
 * @public
 */
com.inq.ui.Container.prototype.fireHidden = function() {
	com.inq.ui.CommandParser.executeLogic(this.styles["onHidden"], false, this);
};

/**
 * getVisible
 *
 * $type TFun([],TDynamic(null))
 * private function getVisible():Dynamic
 * @private
 * @this com.inq.ui.Container
 * @return {boolean} true if visible, false otherwise.
 */
com.inq.ui.Container.prototype.getVisible = function() {
	return this._visible;
};


/**
 * setWidth
 *
 * $type TFun([{ name => val, t => TDynamic(null), opt => false }],TEnum(Void,[]))
 * private function setWidth(val:Dynamic):Void
 * @private
 * @this com.inq.ui.Container
 * @param {null}  val
 * @return {void}
 */
com.inq.ui.Container.prototype.setWidth = function(val) {
	this.styles["width"] = "" + Std.string(val);
};


/**
 * getWidth
 *
 * $type TFun([],TDynamic(null))
 * private function getWidth():Dynamic
 * @private
 * @this com.inq.ui.Container
 * @return {number}
 */
com.inq.ui.Container.prototype.getWidth = function() {
	if(this.styles["visibility"] == "collapse") return 0;
	if(this.styles["width"] != null) return this.evaluatePosition("" + this.styles["width"]);
	/** @type {?string} */
	var sWidth = this._div.style.width;
	if(sWidth != null) return Std.parseInt("" + sWidth);
	return this._div.clientWidth;
};


/**
 * setHeight
 *
 * $type TFun([{ name => val, t => TDynamic(null), opt => false }],TEnum(Void,[]))
 * private function setHeight(val:Dynamic):Void
 * @private
 * @this com.inq.ui.Container
 * @param {null}  val
 * @return {void}
 */
com.inq.ui.Container.prototype.setHeight = function(val) {
	this.styles["height"] = val;
};


/**
 * getHeight
 *
 * $type TFun([],TDynamic(null))
 * public function getHeight():Dynamic
 * @public
 * @this com.inq.ui.Container
 * @return {number}
 */
com.inq.ui.Container.prototype.getHeight = function() {
	if(this.styles["visibility"] == "collapse") return 0;
	if(this.styles["height"] != null) return this.evaluatePosition("" + this.styles["height"]);
	return Std.parseInt("" + Std.string(this._div.style.height));
};


/**
 * getStyle
 *
 * $type TFun([{ name => styleName, t => TInst(String,[]), opt => false }],TDynamic(null))
 * public function getStyle(styleName:String):Dynamic
 * @public
 * @this com.inq.ui.Container
 * @param {string}  styleName
 * @return {string}
 */
com.inq.ui.Container.prototype.getStyle = function(styleName) {
	return this.styles[styleName];
};


/**
 * setStyle
 *
 * $type TFun([{ name => styleName, t => TInst(String,[]), opt => false },{ name => styleValue, t => TDynamic(null), opt => false }],TEnum(Void,[]))
 * public function setStyle(styleName:String, styleValue:Dynamic):Void
 * @public
 * @this com.inq.ui.Container
 * @param {string}  styleName
 * @param {string}  styleValue
 * @return {void}
 */
com.inq.ui.Container.prototype.setStyle = function(styleName,styleValue) {
	this.styles[styleName] = styleValue;
	if(this.parent == null) return;
	this.resize();
	this.resizer(this.contains);
};


/**
 * initStyle
 *
 * $type TFun([{ name => styleName, t => TInst(String,[]), opt => false },{ name => styleValue, t => TDynamic(null), opt => false }],TEnum(Void,[]))
 * public function initStyle(styleName:String, styleValue:Dynamic):Void
 * @public
 * @this com.inq.ui.Container
 * @param {string}  styleName
 * @param {string}  styleValue
 * @return {void}
 */
com.inq.ui.Container.prototype.initStyle = function(styleName,styleValue) {
	this.styles[styleName] = styleValue;
};


/**
 * initAttribute
 *
 *    Add attribute key and value into attributeMap.
 *
 * @public
 * @this com.inq.ui.Container
 * @param {string}  attName
 * @param {Object}  attValue
 * @return
 */
com.inq.ui.Container.prototype.initAttribute = function(attName,attValue) {
	this.attributeMap[attName] = attValue;
};

/**
 * applyAttributeMap
 *
 *    Apply attributes in this.attributeMap to this object.
 *    This function should be called only once.
 *
 * @public
 * @this com.inq.ui.Container
 * @return
 */
com.inq.ui.Container.prototype.applyAttributeMap = function(){
	for(var myKey in this.attributeMap) {
		this.getPrimaryObject().setAttribute(myKey, this.attributeMap[myKey]);
	}
};


/**
 * getPrimaryObject
 *
 *    returns primary object from container,
 *    Container is composed with several HTML Elements.
 *
 * @public
 * @this com.inq.ui.Container
 * @return      {HTML Element}
 */
com.inq.ui.Container.prototype.getPrimaryObject = function(){
	return	this._div;
};


/**
 * setX
 *
 * $type TFun([{ name => val, t => TDynamic(null), opt => false }],TEnum(Void,[]))
 * private function setX(val:Dynamic):Void
 * @private
 * @this com.inq.ui.Container
 * @param {null}  val
 * @return {void}
 */
com.inq.ui.Container.prototype.setX = function(val) {
	this.setStyle("left","" + Std.string(val));
	if(this.parent == null) return;
	this.resize();
	this.resizer(this.contains);
};


/**
 * getX
 *
 * $type TFun([],TDynamic(null))
 * private function getX():Dynamic
 * @private
 * @this com.inq.ui.Container
 * @return {null}
 */
com.inq.ui.Container.prototype.getX = function() {
	/** @type {?string} */
	var styleLeft = this._div.style["left"];
	if (styleLeft != null) {
		return this.evaluatePosition("" + styleLeft);
	}
	return this._div.clientLeft;
};


/**
 * setY
 *
 * $type TFun([{ name => val, t => TDynamic(null), opt => false }],TEnum(Void,[]))
 * private function setY(val:Dynamic):Void
 * @private
 * @this com.inq.ui.Container
 * @param {null}  val
 * @return {void}
 */
com.inq.ui.Container.prototype.setY = function(val) {
	this.setStyle("top","" + Std.string(val));
	this.resize();
	this.resizer(this.contains);
};


/**
 * getY
 *
 * $type TFun([],TDynamic(null))
 * private function getY():Dynamic
 * @private
 * @this com.inq.ui.Container
 * @return {null}
 */
com.inq.ui.Container.prototype.getY = function() {
	/** @type {?string} */
	var styleTop = this._div.style["top"];
	if(styleTop != null) return this.evaluatePosition("" + styleTop);
	return this._div.clientTop;
};


/**
 * whenLoaded - replaces the inline _newim.onload routine
 * The advantages to doing this is that the function is an instance the container class and as such
 * we do not need to keep track of the container instance externally.
 * So all references to the container instance can now be referenced by an implied "this"
 *
 * $type TFun([{ name => ev, t => TDynamic(null), opt => false }],TEnum(Void,[]))
 * private function whenLoaded(ev:Dynamic)
 * @private
 * @this com.inq.ui.Container
 * @param {null}  ev
 * @return {void}
 */
com.inq.ui.Container.prototype.whenLoaded = function(ev) {
	try {
		/** @type {HTMLImageElement} */
		var element = this._backgroundImage;
		/** @type {HTMLImageElement} */
		var imageElement = this._backgroundImage;
		/** @type {HTMLImageElement} */
		var picture = imageElement;
		/** @type {number} */
		var spriteWidth = 0;
		/** @type {number} */
		var spriteHeight = 0;
		/** @type {number} */
		var spriteLeft = 0;
		/** @type {number} */
		var spriteTop = 0;
		/** @type {HTMLElement} */
		var div = this._div;
		/** @type {?HTMLElement} */
		var canvas = null;
		/** @type {Document} */
		var myDoc = imageElement.ownerDocument;
		if (myDoc != this.document) {
			myDoc = this._div.ownerDocument;
			haxe.Log.trace("Document object error, correcting", {
				fileName: "Container.hx",
				lineNumber: 252,
				className: "com.inq.ui.Container",
				methodName: "whenLoaded"
			});
		}

		if (this.getIsSprite()) {
			spriteWidth = this.evaluatePosition(this.getStyle("sprite-width"));
			spriteHeight = this.evaluatePosition(this.getStyle("sprite-height"));
			spriteLeft = this.evaluatePosition(this.getStyle("sprite-left"));
			spriteTop = this.evaluatePosition(this.getStyle("sprite-top"));

			canvas = myDoc.createElement("CANVAS");
			canvas.width = spriteWidth;
			canvas.height = spriteHeight;

			imageElement.width = spriteWidth;
			imageElement.height = spriteHeight;

			picture = canvas;
		}

		this._loadWidth = imageElement.width;
		this._loadHeight = imageElement.height;
		imageElement.style.height = "100%";
		imageElement.style.width = "100%";


		/* If we have a height or width defined in the MXML, then use it to overide loadded size */
		if(this.getStyle("height") == null && (this.getStyle("top") == null || this.getStyle("bottom") == null)) {
			this.initStyle("height","" + Std.string(this._loadHeight));
			picture.style.height = Std.string(this._loadHeight) + "px";
		} else if(this.getStyle("height") != null) picture.style.height = this.evaluatePosition(this.getStyle("height")) + "px";

		if(this.getStyle("width") == null && (this.getStyle("left") == null || this.getStyle("right") == null)) {
			this.initStyle("width","" + Std.string(this._loadWidth));
			picture.style.width = Std.string(this._loadWidth) + "px";
		} else if(this.getStyle("width") != null) picture.style.width = this.evaluatePosition(this.getStyle("width")) + "px";

	    /**
		 * PORTALV2-5449
		 * width and height calculation done above need to be set for the input type image child element too
		 */
		if (this._img) {
		    this._img.style.height = picture.style.height;
		    this._img.style.width = picture.style.width;
		}
		/* remove the first child, if it is an image */
		if(div.firstChild != null && div.firstChild.tagName == "IMAGE") div.removeChild(div.firstChild);
		try {
			div.insertBefore(element,div.firstChild);
		} catch( e ) {
			if( js.Boot.__instanceof(e,Error) ) {
				div.innerHTML = "<IMG style=\"width:100%;height:100%\"  src=\"" + Std.string(imageElement.src) + "\">";
			} else throw(e);
		}
		/* If we are here: we are in IE and IE could not attach an element to elements not in the IFRAME
		 * such as the title bar drag image and the corner drag image.
		 * So we will put them in as HTML tags */

		/* Sprite control using canvas feature
		 * Since canvas is only in HTML5, let us test to see if we can do it
		 *
		 * We basically decided if we where a sprite in SkinLoader.hx
		 */
		if(this.getIsSprite()) {
			canvas.style.cssText = imageElement.style.cssText;
			canvas.id = Std.string(imageElement.parentNode.id) + "_canvas";

			/* Now overload canvas
			 * we add the following overloads, sprite top, left, width, and height, and
			 * a refernece to the image
			 */
			canvas["sourceImage"] = imageElement;
			canvas["spriteTop"] = spriteTop;
			canvas["spriteLeft"] = spriteLeft;
			canvas["spriteWidth"] = spriteWidth;
			canvas["spriteHeight"] = spriteHeight;

			/* move the canvas to be positioned directly after the image */
			imageElement.parentNode.insertBefore(canvas,imageElement.nextSibling);
			/* hide the image */
			imageElement.style.display = "none";
			this.renderCanvas(canvas);/* Now render the canvas */
		}

		this.resize();
	} catch( e ) {
		haxe.Log.trace("ERROR: " + Std.string(e),{ fileName : "Container.hx", lineNumber : 340, className : "com.inq.ui.Container", methodName : "whenLoaded"});
	}
};


/**
 * setBackgroundImage
 *
 * @see com.inq.ui.SkinLoader.prototype.applyAttributes
 * @public
 * @this com.inq.ui.Container
 * @param   val    - background image path
 * @param   hide   - {boolean} value true - hide in accessibility. Default is true.
 * @return {void}
 */
com.inq.ui.Container.prototype.setBackgroundImage = function (val, hide) {
	this.setStyle("backgroundImage", val);
	if (this.styles["backgroundImage"] == null || this.styles["backgroundImage"] == "") {
		return;
	}

	this._backgroundImage = this.getNewImage();
	this._backgroundImage.onload = $bind(this, this.whenLoaded);
	this._backgroundImage.className = com.inq.ui.Container.CHAT_CLASS;
	this._backgroundImage.src = this.styles["backgroundImage"];

	var isHide = (typeof hide == "undefined") ? true : hide;
	if (isHide) {
		this._backgroundImage.setAttribute("aria-hidden", "true");
		this._backgroundImage.setAttribute("alt", "");
		this._backgroundImage.setAttribute("tabindex", "-1");
	}
};


/**
 * getID - get the identifier for the container
 *
 * $type TFun([],TInst(String,[]))
 * public function getID():String
 * @public
 * @this com.inq.ui.Container
 * @return {?string} - the ID for the container or null
 */
com.inq.ui.Container.prototype.getID = function() {
	return this.styles["id"];
};


/**
 * setID - set the identifier for the container
 *
 * $type TFun([{ name => val, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * public function setID(val:String):Void
 * @public
 * @this com.inq.ui.Container
 * @param {string}  val
 * @return {void}
 */
com.inq.ui.Container.prototype.setID = function (val) {

    if (com.inq.flash.client.control.FlashPeer.getIsBuilder()) {

        var alreadyPrepended = val.indexOf(com.inq.ui.Container.CLIENT_SPACE_PREFIX) == 0 || val.indexOf(com.inq.ui.Container.LEGACY_PREFIX) == 0;
        var prefixedId = val;
        if (this._div.ownerDocument != window.document && !alreadyPrepended) {
	        prefixedId = com.inq.ui.Container.CLIENT_SPACE_PREFIX + val;
        }
        this._div.id = prefixedId;
        this.styles["id"] = val;

    }
    else {
		if (this._div.ownerDocument != null && this._div.ownerDocument == window.document && !com.inq.flash.client.control.FlashPeer.noV3FrameChat() || !com.inq.ui.SkinLoader.hasClientBody) {
			this._div.id = val;
		} else {
			this._div.id = val.indexOf(com.inq.ui.Container.CLIENT_SPACE_PREFIX) == 0 || val.indexOf(com.inq.ui.Container.LEGACY_PREFIX) == 0
				? val : com.inq.ui.Container.CLIENT_SPACE_PREFIX + val;
		}
        this.styles["id"] = val
    }
};

/**
 * setAttribute - set attribute for the container's _div
 *
 * public function setAttribute(val:String, val:String):Void
 * @public
 * @this com.inq.ui.Container
 * @param {string}  attName
 * @param {string}  attValu
 * @return {void}
 */
com.inq.ui.Container.prototype.setAttribute = function(attName, attValu) {
	if (typeof this._div != "undefined")	{
		this._div.setAttribute(attName, attValu);
	}
};

/**
 * addHtmlLabel - add label to the container. the lable's for attribute is pointing to the firstChild element.
 *
 * public function addHtmlLabel(val:String):Void
 * @public
 * @this com.inq.ui.Container
 * @param {string}  val
 * @return {void}
 */
com.inq.ui.Container.prototype.addHtmlLabel = function(val) {
	if (typeof this._div != "undefined")	{
		/** @type {HTMLElement} */
		var label = document.createElement("label");
		if(this.getHtmlLabelObject()) {
			label.setAttribute("for", this.getHtmlLabelObject().id);
		}
		label.setAttribute('style', 'position: absolute; left: -9999');
		label.innerHTML = val;
		this._div.appendChild(label);
		this._htmlLabel = label;
	}
};

/**
 * getHtmlLabelObject - returns appropriate object to label for.
 *
 * public function getHtmlLabelObject():Object
 * @public
 * @this com.inq.ui.Container
 * @return {?Node}
 */
com.inq.ui.Container.prototype.getHtmlLabelObject = function() {
	/** @type {?Node} */
	var labelObjet = null;
	if(typeof this._div != "undefined") {
		labelObjet = this._div.firstChild;
	}
	return labelObjet;
};

/**
 * setFocus
 *
 * $type TFun([],TEnum(Void,[]))
 * public function setFocus():Void
 * @public
 * @this com.inq.ui.Container
 * @return {void}
 */
com.inq.ui.Container.prototype.setFocus = function() {
	try {
		this._div.focus();
	} catch( e ) {
		if( js.Boot.__instanceof(e,Error) ) {
		} else throw(e);
	}
};


/**
 * setEnabled
 *
 * $type TFun([{ name => val, t => TEnum(Bool,[]), opt => false }],TDynamic(null))
 * public function setEnabled(val:Bool):Dynamic
 * @public
 * @this com.inq.ui.Container
 * @param {boolean}  val
 * @return {null} -
 */
com.inq.ui.Container.prototype.setEnabled = function(val) {
	if(this._div != null) this._div.disabled = val?false:true;

	if(val) com.inq.ui.CommandParser.executeLogic(this.styles["onEnable"],false,this);
};


/**
 * getEnabled
 *
 * $type TFun([],TDynamic(null))
 * public function getEnabled():Dynamic
 * @public
 * @this com.inq.ui.Container
 * @return {null} -
 */
com.inq.ui.Container.prototype.getEnabled = function() {
	if(this._div != null) return this._div.disabled?false:true; else return false;
};


/**
 * clear
 *
 * $type TFun([],TEnum(Void,[]))
 * public function clear():Void
 * @public
 * @this com.inq.ui.Container
 * @return {void}
 */
com.inq.ui.Container.prototype.clear = function() {
	/** @type {HTMLElement} */
	var ob = this._div;
	while(ob.lastChild != null) ob.removeChild(ob.lastChild);
};


/**
 * Set default on click handler
 * --------------------- *
 *
 * $type TFun([{ name => whenClicked, t => TDynamic(null), opt => false }],TEnum(Void,[]))
 * public function setOnClick(whenClicked:Dynamic):Void
 * @public
 * @this com.inq.ui.Container
 * @param {null}  whenClicked
 * @return {void}
 */
com.inq.ui.Container.prototype.setOnClick = function(whenClicked) {
	this._div.onclick = whenClicked;
};

com.inq.ui.Container.prototype.cleanUp = function () {};

/**
 * setLabel is used as stub method to set "label" attribute.
 */
com.inq.ui.Container.prototype.setLabel = function () {};

/** @private @type {boolean} */
com.inq.ui.Container.prototype._clientStage = null;
/** @type {null} */
com.inq.ui.Container.prototype.document = null;
/** @type {com.inq.ui.Container} */
com.inq.ui.Container.prototype.parent = null;
/** @private @type {boolean} */
com.inq.ui.Container.prototype._isSprite = null;
/** @type {boolean} */
com.inq.ui.Container.prototype.isSprite = null;
/** @type {null} */
com.inq.ui.Container.prototype.scrolling = null;
/** @type {null} */
com.inq.ui.Container.prototype.src = null;
/** @type {null} */
com.inq.ui.Container.prototype.x = null;
/** @type {null} */
com.inq.ui.Container.prototype.y = null;
/** @private @type {null} */
com.inq.ui.Container.prototype._parent = null;
/** @type {null} */
com.inq.ui.Container.prototype.width = null;
/** @private @type {null} */
com.inq.ui.Container.prototype._width = null;
/** @type {null} */
com.inq.ui.Container.prototype.enabled = null;
/** @type {null} */
com.inq.ui.Container.prototype.height = null;
/** @private @type {null} */
com.inq.ui.Container.prototype._height = null;
/** @private @type {null} */
com.inq.ui.Container.prototype.styles = null;
/** @private @type {Object} */
com.inq.ui.Container.prototype.attributeMap = null;
/** @type {null} */
com.inq.ui.Container.prototype.visible = null;
/** @private @type {boolean} */
com.inq.ui.Container.prototype._visible = null;
/** @private @type {string} */
com.inq.ui.Container.prototype._style = null;
/** @type {Array} */
com.inq.ui.Container.prototype.contains = null;
/** @type {null} */
com.inq.ui.Container.prototype._loadHeight = null;
/** @type {null} */
com.inq.ui.Container.prototype._loadWidth = null;
/** @type {null} */
com.inq.ui.Container.prototype._div = null;
/** @type {HTMLLabelElement} */
com.inq.ui.Container.prototype._htmlLabel = null;
/** @type {string} */
com.inq.ui.Container.CLIENT_SPACE_PREFIX = "tcChat_";

/** @type {string} */
com.inq.ui.Container.LEGACY_PREFIX = "inq";

/** @type {string} */
com.inq.ui.Container.CHAT_CLASS = "tcChat";

/** @type {string} */
com.inq.ui.Container.SC_TITLEBAR = "inqTitleBar";

/** @type {string} */
com.inq.ui.Container.SC_RESIZE = "inqDivResizeCorner";

/** @type {string} */
com.inq.ui.Container.SC_SKIN = "tcChat_Skin";

/** @private @type {number} */
com.inq.ui.Container.count = 0;
